import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesDashboard } from "../../constants";
import { StatisticRequestParams, StatisticResponse } from "./statistic.types";

export const requestStatistic = async (
  params: StatisticRequestParams
): Promise<StatisticResponse> => {
  return await instance.get(buildUrl(ApiRoutesDashboard.Statistics), {
    params
  });
};
